import { useEffect } from "react";

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  const selector = attr === "name" ? `meta[name="${key}"]` : `meta[property="${key}"]`;
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export interface JsonLd {
  "@context": string;
  "@type": string;
  [key: string]: unknown;
}

export function useSeo(opts: {
  title: string;
  description: string;
  canonical?: string;
  jsonLd?: JsonLd | JsonLd[];
}) {
  useEffect(() => {
    document.title = opts.title;
    upsertMeta("name", "description", opts.description);
    upsertMeta("property", "og:title", opts.title);
    upsertMeta("property", "og:description", opts.description);
    upsertMeta("name", "twitter:title", opts.title);
    upsertMeta("name", "twitter:description", opts.description);
    if (opts.canonical) upsertCanonical(opts.canonical);

    if (opts.jsonLd) {
      const id = `jsonld-${opts.canonical || "page"}`;
      document.getElementById(id)?.remove();
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = id;
      script.textContent = JSON.stringify(opts.jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      if (opts.jsonLd) document.getElementById(`jsonld-${opts.canonical || "page"}`)?.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opts.title, opts.description, opts.canonical]);
}